document.addEventListener("DOMContentLoaded", () => {

    let videoTestimonialsSwipers = document.getElementsByClassName('video-testimonials-swiper');

    for (let i = 0; i < videoTestimonialsSwipers.length; i++) {

        let swiperElement = videoTestimonialsSwipers[i];

        let elementID = swiperElement.dataset.elementid;
        let swiperID = '#' + swiperElement.id;

        let nextElButtonClass = '.video-testimonials-next-' + elementID;
        let prevElButtonClass = '.video-testimonials-prev-' + elementID;

        const swiper = new Swiper(swiperID, {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1.5,
            spaceBetween: 20,
            navigation: {
                nextEl: nextElButtonClass,
                prevEl: prevElButtonClass,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 1.5,
                },
                1200: {
                    slidesPerView: 2.5,
                },
                1440: {
                    slidesPerView: 3.5,
                }
            }
        });

    }
});
